import api from '@pray/shared/utils/api';

import type { UpdateFeatureFlagInput } from './types';

export const updateFeatureFlag = async (flagId: string, data: UpdateFeatureFlagInput) => {
  if (!flagId) throw Error('Flag ID is required');

  const url = `/web/studio/feature-flags/${flagId}`;
  const response = await api.executePutRequest(url, data);
  return response.data;
};
